const DEFAULT_PUBLIC_SITE_URL = 'https://www.talesofreval.ee';
const CANONICAL_PUBLIC_HOST = 'www.talesofreval.ee';
const DEPRECATED_PUBLIC_HOSTS = new Set(['preview.talesofreval.ee', 'talesofreval.ee']);

export const normalizePublicSiteUrl = (value = '', fallback = DEFAULT_PUBLIC_SITE_URL) => {
  const candidate = String(value || fallback).trim();

  if (!candidate) {
    return fallback;
  }

  try {
    const url = new URL(candidate);

    if (DEPRECATED_PUBLIC_HOSTS.has(url.hostname.toLowerCase())) {
      url.hostname = CANONICAL_PUBLIC_HOST;
      url.port = '';
    }

    return url.toString().replace(/\/+$/, '');
  } catch (_error) {
    return fallback;
  }
};

export { DEFAULT_PUBLIC_SITE_URL };
